
import React, { Fragment } from "react";
import { FailurePanel } from "components/notifications/FailurePanel";

export function LicenceCheckingConsentError() {
    return (
        <Fragment>
                <FailurePanel title="Error With Declaration">
                    <p>
                        There was an error getting your declaration. <br />
                        The link has expired or your declaration has already been completed.
                    </p>
                </FailurePanel>
        </Fragment>
    );
}
